import styled from 'styled-components';

import { useOrderFormView } from '#/features/perpetuals/order-builder/form-context';

import Description from '#/components/perpetuals/Description';

export default function OrderSummary() {
  const formView = useOrderFormView();

  return (
    <Container>
      <Description label="Fee" value={formView.feeRange} />
      <Description
        label="Notional"
        value={formView.notionalQuoteAsset.formattedValue}
      />
    </Container>
  );
}

export const Container = styled.div`
  display: grid;
  gap: 12px;
`;
